module.exports = __webpack_public_path__ + "042891e08aa52137c295cef821d90aae.svg";